import { render, staticRenderFns } from "./RentalGIn.vue?vue&type=template&id=4ba04be8&scoped=true"
import script from "./RentalGIn.vue?vue&type=script&lang=js"
export * from "./RentalGIn.vue?vue&type=script&lang=js"
import style0 from "./RentalGIn.vue?vue&type=style&index=0&id=4ba04be8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba04be8",
  null
  
)

export default component.exports